export default "__VITE_ASSET__D7nv9alb__"